/**
 * @description 前台 Service 层
 * http://test.convention-docs.shuwen.com/swagger-ui.html#/
 */

import { normalizeResult } from '@/utils/tool';
import request from '@/utils/request';
const baseUrl = '/api/v1';

// 获取专题列表
export async function getTopicList(payload: any) {
  const res = await request(`${baseUrl}/topic/list`, {
    method: 'POST',
    body: payload
  });
  return normalizeResult<any>(res);
}

// 查询专题视频详情
export async function getActivityListDetail(id: any) {
  const res = await request(`${baseUrl}/activity/${id}`, {
    method: 'get',
  });
  return normalizeResult<any>(res);
}

// 获取活动列表
export async function getActivityList(payload: any) {
  const res = await request(`${baseUrl}/activity/list`, {
    method: 'POST',
    body: payload
  });
  return normalizeResult<any>(res);
}

// 获取各地新闻 列表
export async function getNewsList(payload: any) {
  const res = await request(`${baseUrl}/news/list`, {
    method: 'POST',
    body: payload,
  });
  return normalizeResult<any>(res);
}

// 查询各地新闻详情
export async function getNewsDetail(id: any) {
  const res = await request(`${baseUrl}/news/${id}`, {
    method: 'get',
  });
  return normalizeResult<any>(res);
}

// 获取主题日新闻列表（素材列表）
export async function getMediaList(payload: any) {
  const res = await request(`${baseUrl}/media/list`, {
    method: 'POST',
    body: payload,
  });
  return normalizeResult<any>(res);
}

// 查询主题日新闻详情
export async function getMediaDetail(id: any) {
  const res = await request(`${baseUrl}/media/${id}`, {
    method: 'get',
  });
  return normalizeResult<any>(res);
}

// 活动点赞
export async function setActivityLike(id: any) {
  const res = await request(`${baseUrl}/activity/nice?boothId=${id}`, {
    method: "get",
  });
  return normalizeResult<any>(res);
}

// 新闻点赞
export async function setNewsLike(id: any) {
  const res = await request(`${baseUrl}/news/praise?boothId=${id}`, {
    method: "get",
  });
  return normalizeResult<any>(res);
}

// 展位详情点赞
export async function companyDetailLike(id: any) {
  const res = await request(`${baseUrl}/booth/praise?boothId=${id}`, {
    method: "get",
  });
  return normalizeResult<any>(res);
}

// 字典列表查询
export async function getDictList(payload: any) {
  const res = await request(`${baseUrl}/dict/list`, {
    method: 'POST',
    body: payload,
  });
  return normalizeResult<any>(res);
}

// 获取论坛详情
export async function getBbsDetail(id: any) {
  const res = await request(`${baseUrl}/bbs/${id}`, {
    method: 'get',
  });
  return normalizeResult<any>(res);
}

 // 查询嘉宾
 export async function getVipUserList() {
  const res = await request(`${baseUrl}/vip-user/list`, {
    method: 'POST',
    body: {
      status: 1,
    },
  });
  return normalizeResult<any>(res);
}

// 查询图片新闻
export async function getImgNewsList(payload: any) {
  const res = await request(`${baseUrl}/journalism/list`, {
    method: 'POST',
    body: {
      status: 1,
      ...payload,
    },
  });
  return normalizeResult<any>(res);
}

// 获取图片新闻详情
export async function getImgNewsDetail(id: any) {
  const res = await request(`${baseUrl}/journalism/${id}`, {
    method: 'get',
  });
  return normalizeResult<any>(res);
}

// 新闻列表，获取全部新闻
export async function getAllNews() {
  const res = await request(`${baseUrl}/all-new/list`, {
    method: 'get',
  });
  return normalizeResult<any>(res);
}
